import BaseProxy from '../base-proxy';

/**
 * Class SettingsProxy
 */
class SettingsProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/e-invoice-api/api', parameters);
    this.defaultOptions = { allowToast: false };
  }

  getSettingListEnum(options = {}) {
    return this.submit('get', `${this.endpoint}/setting/get-list-enum`, null, { ...this.defaultOptions, ...options });
  }

  /* ================================================ Seller Setting ================================================ */

  getSellerSettingList(options = {}) {
    return this.submit('get', `${this.endpoint}/seller-setting/list`, null, { ...this.defaultOptions, ...options });
  }

  getSellerSettingGuidelines(options = {}) {
    return this.submit('get', `${this.endpoint}/seller-setting/guideline`, null, { ...this.defaultOptions, ...options });
  }

  searchTaxCodeOnDB(taxCode) {
    return this.submit('get', `${this.endpoint}/buyers/search?phone=${taxCode}`);
  }
}

export default SettingsProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/e-invoice/settings-proxy.js